import { render } from "./RegularScheduleSection.vue?vue&type=template&id=30f572c3&scoped=true&ts=true"
import script from "./RegularScheduleSection.vue?vue&type=script&lang=ts"
export * from "./RegularScheduleSection.vue?vue&type=script&lang=ts"

import "./RegularScheduleSection.vue?vue&type=style&index=0&id=30f572c3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f572c3"]])

export default __exports__